import { render } from "./AddMovie.vue?vue&type=template&id=5e7c953c&scoped=true&ts=true"
import script from "./AddMovie.vue?vue&type=script&lang=ts"
export * from "./AddMovie.vue?vue&type=script&lang=ts"

import "./AddMovie.vue?vue&type=style&index=0&id=5e7c953c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/chronicle/chronicle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7c953c"]])

export default __exports__